module.exports = __webpack_public_path__ + "img/sol_cap4.f21e5005.png";